import React from 'react';
import './Timeline.css';

function Timeline({ selectedMonth, selectedYear, onDayClick, onYearChange, events, hasEvents }) {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  // Trump presidency years
  const presidencyYears = [
    { year: 2017, term: "First Term" },
    { year: 2018, term: "First Term" },
    { year: 2019, term: "First Term" },
    { year: 2020, term: "First Term" },
    { year: 2021, term: "First Term" },
    { year: 2025, term: "Second Term" },
    { year: 2026, term: "Second Term" },
    { year: 2027, term: "Second Term" },
    { year: 2028, term: "Second Term" },
    { year: 2029, term: "Second Term" }
  ];

  // Calculate days in the selected month and year
  const getDaysInMonth = (year, month) => {
    // Month is 0-indexed in JS Date
    return new Date(year, month + 1, 0).getDate();
  };

  // Calculate days since inauguration based on the presidency term
  const getDaysSinceInauguration = (year, month, day) => {
    let inaugurationDate;
    let currentDate = new Date(year, month, day);
    
    // First term: Jan 20, 2017 to Jan 20, 2021
    // Second term: Jan 20, 2025 to Jan 20, 2029
    if (year >= 2017 && year <= 2021) {
      inaugurationDate = new Date(2017, 0, 20); // Jan 20, 2017
    } else if (year >= 2025 && year <= 2029) {
      inaugurationDate = new Date(2025, 0, 20); // Jan 20, 2025
    } else {
      return null; // Not during presidency
    }

    // Calculate days difference
    return Math.floor((currentDate - inaugurationDate) / (24 * 60 * 60 * 1000)) + 1;
  };

  // Check if a date is active (after inauguration)
  const isDateActive = (year, month, day) => {
    // First term: starts Jan 20, 2017
    if (year === 2017 && month === 0 && day < 20) {
      return false;
    }
    
    // First term: ends Jan 20, 2021
    if (year === 2021 && (month > 0 || (month === 0 && day > 20))) {
      return false;
    }
    
    // Second term: starts Jan 20, 2025
    if (year === 2025 && month === 0 && day < 20) {
      return false;
    }
    
    // Second term: ends Jan 20, 2029
    if (year === 2029 && (month > 0 || (month === 0 && day > 20))) {
      return false;
    }
    
    return true;
  };

  const renderDays = () => {
    const daysInMonth = getDaysInMonth(selectedYear, selectedMonth);
    const days = [];
    
    // Add day headers for each day of the week
    const dayHeaders = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    dayHeaders.forEach(day => {
      days.push(
        <div key={`header-${day}`} className="day-header">
          {day}
        </div>
      );
    });

    // Add empty slots for days before the first day of the month
    const firstDayOfMonth = new Date(selectedYear, selectedMonth, 1).getDay();
    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<div key={`empty-${i}`} className="day-placeholder"></div>);
    }

    // Add the actual days of the month
    for (let i = 1; i <= daysInMonth; i++) {
      // Check if this date is active during presidency
      const isActive = isDateActive(selectedYear, selectedMonth, i);
      
      // Calculate days since inauguration
      const daysSinceInauguration = isActive ? getDaysSinceInauguration(selectedYear, selectedMonth, i) : null;
      
      // Special days
      const isInaugurationDay = (
        (selectedYear === 2017 && selectedMonth === 0 && i === 20) || 
        (selectedYear === 2025 && selectedMonth === 0 && i === 20)
      );
      const isJuly4th = selectedMonth === 6 && i === 4;
      
      // Check if this day has events using the hasEvents function passed from App
      const dayHasEvents = hasEvents ? hasEvents(selectedYear, selectedMonth, i) : false;
      
      let specialClass = '';
      if (isInaugurationDay) specialClass = 'inauguration-day';
      if (isJuly4th) specialClass = 'july-fourth';

      days.push(
        <button
          key={i}
          className={`day-button ${isActive ? 'active' : 'inactive'} ${specialClass} ${dayHasEvents ? 'has-events' : ''}`}
          onClick={() => isActive && onDayClick(i, daysSinceInauguration)}
          disabled={!isActive}
          aria-label={`${months[selectedMonth]} ${i}, ${selectedYear}${dayHasEvents ? ' - Has events' : ''}`}
        >
          <span className="day-number">{i}</span>
          {isActive && daysSinceInauguration && <span className="presidency-day">Day {daysSinceInauguration}</span>}
          {isInaugurationDay && <div className="special-icon inauguration"></div>}
          {isJuly4th && <div className="special-icon july4"></div>}
          {dayHasEvents && <div className="event-indicator"></div>}
        </button>
      );
    }
    
    return days;
  };

  // Get the current presidency term
  const getCurrentTerm = () => {
    const yearData = presidencyYears.find(item => item.year === selectedYear);
    return yearData ? yearData.term : "";
  };

  return (
    <div className="timeline-container">
      {/* Year selector */}
      <div className="year-selector">
        <select 
          value={selectedYear}
          onChange={(e) => onYearChange(parseInt(e.target.value))}
          className="year-dropdown"
          aria-label="Select year"
        >
          {presidencyYears.map((item) => (
            <option key={item.year} value={item.year}>
              {item.year} ({item.term})
            </option>
          ))}
        </select>
      </div>

      <div className="month-header">
        <div className="star-left"></div>
        <h2>{months[selectedMonth]} {selectedYear} - {getCurrentTerm()}</h2>
        <div className="star-right"></div>
      </div>
      
      <div className="days-container">
        {renderDays()}
      </div>
    </div>
  );
}

export default Timeline;